<template>
    <div class="container-fluid" >
        <headerApp :title="this.translate('termsTitle')"></headerApp>
        <div class="row">
            <div class="col-xs-24">
                <div class="col-container">
                    <div id='form' class='form row'>
                        <loader class="terms-loader" :flag="!terms" :customAttribute="{tag: 'circle', children: 0, attribute:'stroke', value: '--main-color'}" ></loader>
                        <span v-html="terms"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'terms',
    data () {
        return {
        };
    },
    computed: {
        ...mapGetters({
            terms: 'company/terms'
        })
    },
    mounted () {
        this.language = this.$getLang();
        this.getTerms(this.language);
    },
    methods: {
        ...mapActions({
            getTerms: 'company/getTerms'
        })
    }
};
</script>

<style scoped>
    .container-fluid {
        background: var(--form-background-color);
        min-height: 100%;
    }
    .col-container {
        padding: 0 .4em;
    }
   .form {
        padding: 1.4em;
        margin: 1.2em 0;
        background-color: white;
        box-shadow: 0px 1px 5px 3px rgba(0, 0, 0, .1);
    }
    p {
        margin-top: 0;
    }
    .terms-loader {
        text-align: center;
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/Terms.vue